import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type CourseDetail } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: CourseDetail.Api.InitRequest
  ): Promise<HttpApiResponse<CourseDetail.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/detail`, args),
  lessonEvent: (
    apiInfo: ModuleApiInfo,
    courseId: string,
    lessonId: string,
    event: "enter" | "leave"
  ): Promise<HttpApiResponse<CourseDetail.Api.LessonEventResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/courses/${courseId}/lessons/${lessonId}/${event}`),
  getCourse: (
    apiInfo: ModuleApiInfo,
    args: CourseDetail.Api.GetCourseRequest
  ): Promise<HttpApiResponse<CourseDetail.Api.GetCourseResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/${args.id}`),
  getLessonDetail: (
    apiInfo: ModuleApiInfo,
    courseId: string,
    id: string
  ): Promise<HttpApiResponse<CourseDetail.Api.GetLessonDetailResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/${courseId}/lessons/${id}`),
  quizProceed: (
    apiInfo: ModuleApiInfo,
    courseId: string,
    lessonId: string,
    questionId?: string,
    answerIds?: string[]
  ): Promise<HttpApiResponse<CourseDetail.Api.QuizProceedResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/${courseId}/quiz/${lessonId}/proceed`, {
      questionId,
      answerIds
    }),
  quizReview: (
    apiInfo: ModuleApiInfo,
    courseId: string,
    lessonId: string,
    questionId?: string
  ): Promise<HttpApiResponse<CourseDetail.Api.QuizReviewResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/${courseId}/quiz/${lessonId}/review`, {
      questionId
    })
};
